import React, { useCallback, useEffect, useState } from 'react';
import Cropper from 'react-easy-crop';
import { Grid, Button } from '@mui/material';

function ImageCropper ({
    image, savetoAWS , setOpenCrop = () => {}
}) {

    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [previewImage, setPreviewImage] = useState("");
    const [imageSize, setImageSize] = useState({ width: 0, height: 0 });

    useEffect(() => {
        console.log('here image', image)
        if (!image) return;
        createImage(image).then(img => {
            setImageSize({ width: img.width, height: img.height });
            createThumbnail(image).then(setPreviewImage);
        });
    }, [image]);

        // Helper
    const createThumbnail = async (src, maxSize = 800) => {
        const img = await createImage(src);
        const scale = Math.min(maxSize / img.width, maxSize / img.height, 1);
        const canvas = document.createElement("canvas");
        canvas.width = img.width * scale;
        canvas.height = img.height * scale;
        canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
        return canvas.toDataURL("image/jpeg");
    };

    const getCroppedImg = async (imageSrc, pixelCrop) => {
        const image = await createImage(imageSrc);
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;

        ctx.drawImage(
            image,
            pixelCrop.x,
            pixelCrop.y,
            pixelCrop.width,
            pixelCrop.height,
            0,
            0,
            pixelCrop.width,
            pixelCrop.height
        );

        return new Promise((resolve) => {
            canvas.toBlob((blob) => {
                resolve(blob);
                // Cleanup
                canvas.width = 0;
                canvas.height = 0;
            }, "image/png");
        });
    };

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    // const debouncedCropComplete = useDebouncedCallback(
    //     (croppedArea, croppedAreaPixels) => setCroppedAreaPixels(croppedAreaPixels), 50 // ms
    // );

    // Helper to load image
    const createImage = (url) => new Promise((resolve, reject) => {
        const image = new Image();
        image.addEventListener("load", () => resolve(image));
        image.addEventListener("error", (error) => reject(error));
        image.setAttribute("crossOrigin", "anonymous"); // avoid CORS issues
        image.src = url;
    });

    const handleSave = async () => {
        try {
            if (!croppedAreaPixels || !image) return;

            const croppedBlob = await getCroppedImg(image, croppedAreaPixels);

            const croppedFile = new File([croppedBlob], `${Date.now()}.png`, {
                type: "image/png",
            });

            if (typeof image === "string" && image.startsWith("blob:")) {
                URL.revokeObjectURL(image);
            }

            // save to aws and return
            if (savetoAWS) { 
                savetoAWS(croppedFile)
                return;
            }

            setOpenCrop(croppedFile);
        } catch (e) {
            console.error("Crop error:", e);
        }
    };

    return (
        <div style={{
            position: "relative",
            width: '70vw',
            maxWidth: "444px",
            minHeight: "350px",
            background: "#333",
            marginBottom: 40
        }}>
            <div className="crop-container">
                <Cropper
                    image={image} // Replace with your image URL
                    crop={crop}
                    zoom={zoom}
                    aspect={1 / 1} // For a perfect circle, maintain a 1:1 aspect ratio
                    cropShape="round" // This line makes the crop area circular
                    onCropChange={setCrop}
                    onZoomChange={setZoom}
                    onCropComplete={onCropComplete}
                />
            </div>
            <div
                style={{
                    position: "absolute",
                    bottom: "10px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    zIndex: 999,
                    background: "rgba(0,0,0,0.5)",
                    padding: "6px 12px",
                    borderRadius: "12px",
                }}
            >
                <button
                    onClick={() => setZoom(z => Math.max(0.5, z - 0.1))}
                    style={{ color: "white", fontSize: "18px", background: "transparent", border: "none" }}
                >➖</button>
                <input
                    type="range"
                    min={0.5}
                    max={3}
                    step={0.01}
                    value={zoom}
                    onChange={(e) => setZoom(Number(e.target.value))}
                    style={{ width: "150px" }}
                />
                <button
                    onClick={() => setZoom(z => Math.min(3, z + 0.1))}
                    style={{ color: "white", fontSize: "18px", background: "transparent", border: "none" }}
                >➕</button>
            </div>
            <div
                style={{
                    position: "absolute",
                    bottom: "-38px",
                    left: 0, right: 0,
                    backgroundColor: '#0198E1',
                    gap: "0.5rem",
                    zIndex: 999,
                }}
            >
                <Grid item xs={12} style={{
                    backgroundColor: '#0198E1',
                }}>
                    <Button 
                        variant='contained' 
                        style={{
                            backgroundColor: '#0198E1'
                        }} 
                        fullWidth
                        onClick={() => {
                            handleSave()
                        }}
                    >Save</Button>
                </Grid>
            </div>
        </div>
    );
};

export default ImageCropper;